/**
 * Clock service for time operations
 * Allows for time mocking in tests
 */

import * as Effect from 'effect/Effect';
import * as Context from 'effect/Context';
import * as Layer from 'effect/Layer';

export class Clock extends Context.Tag('Clock')<
  Clock,
  {
    readonly now: () => Effect.Effect<Date, never>;
    readonly timestamp: () => Effect.Effect<number, never>;
    readonly isoString: () => Effect.Effect<string, never>;
  }
>() {}

export const ClockLive = Layer.succeed(Clock, {
  now: () => Effect.sync(() => new Date()),
  timestamp: () => Effect.sync(() => Date.now()),
  isoString: () => Effect.sync(() => new Date().toISOString()),
});
